/* template */
<template><page><base-container :class='["tab-bar-view"]'><div :class='["content"]'><div :class='["section"]'><tab-bar-default></tab-bar-default></div><div :class='["section"]'><tab-bar-slider></tab-bar-slider></div><div :class='["section"]'><tab-bar-inline></tab-bar-inline></div><div :class='["section"]'><tab-bar-slot></tab-bar-slot></div></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_5354c589"}'>
.tab-bar-view
  height: 100vh
  .section
    margin-bottom: 10px
    background-color: white
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_5354c589"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_5354c589"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_5354c589"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'tab-bar-default':getComponent(require("./tab-bar-default.mpx?isComponent&outputPath=components%2Ftab-bar-default63efd2f4%2Findex")),'tab-bar-slider':getComponent(require("./tab-bar-slider.mpx?isComponent&outputPath=components%2Ftab-bar-slider6220f06a%2Findex")),'tab-bar-inline':getComponent(require("./tab-bar-inline.mpx?isComponent&outputPath=components%2Ftab-bar-inline4e927e22%2Findex")),'tab-bar-slot':getComponent(require("./tab-bar-slot.mpx?isComponent&outputPath=components%2Ftab-bar-slot1b5f9387%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>